<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">
                Close
            </v-btn
            >
        </v-snackbar
        >
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :headers="headers"
                        :items="contactInfos"
                        sort-by="Address"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Contacts Information"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Contact</v-toolbar-title>
                                <v-divider
                                    class="mx-2"
                                    inset
                                    vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <action-control-menu
                                    ref="actions"
                                    :actions="['Print', 'Download']"
                                    :navigateTo="navigateTo"
                                    :payload="payload"
                                    btnTitle="New"
                                />
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ma3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2 hidden-sm-and-down"
                                @click="viewContactInfo(item)"
                            >
                                mdi-eye
                            </v-icon>

                            <v-btn
                                outlined
                                medium
                                class="mr-4 hidden-md-and-up"
                                color="light-blue darken-4"
                                @click="viewContactInfo(item)"
                            >
                                view
                            </v-btn>

                            <v-icon
                                small
                                class="hidden-sm-and-down"
                                @click="deleteContactInfo(item)"
                            >
                                mdi-delete
                            </v-icon>

                            <v-btn
                                medium
                                outlined
                                class="hidden-md-and-up red--text"
                                @click="deleteContactInfo(item)"
                            >
                                delete
                            </v-btn>
                        </template>
                        <template v-slot:no-data>
                            <v-btn
                                color="#2b3990"
                                class="white--text"
                                @click="getContactInfos()"
                            >Reset
                            </v-btn
                            >
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>
        <OptionMenu :onAction="handleActions"/>
    </div>
</template>

<script>
import axios from "axios";
import ClientNav from "../../components/ClientNav";
import ClientSide from "../../components/ClientSide";
import Foot from "../../components/Footer";
import ActionControlMenu from "@/components/ActionControlMenu";
import { mapGetters } from "vuex";
// import moment from 'moment'

const url = require("../../client_config/config").url;

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ActionControlMenu,
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Name",
                    align: "start",
                    sortable: false,
                    value: "Name",
                },
                {text: "Phone", value: "CellPhone"},
                {text: "Email", value: "Email"},
                {text: "Address", value: "Address"},
                {text: "City", value: "City"},
                {text: "State", value: "State"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            dialog: false,
            editContactInfo: false,
            newContactInfo: false,
            msg: false,
            search: "",
            text: "",
            contactInfos: [],
            users: [],
            types: [
                "Guardian",
                "Mother",
                "Father",
                "Emergency Contact",
                "Employer",
            ],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem("userID"),
            tempData: [],
            titleForm: "New Contact Information",
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            payload: {}
        };
    },

    computed: {
        formTitle() {
            return this.editedIndex !== 1 ? "New Item" : "Edit Item";
        },
        ...mapGetters({
            client: "clients/clientData",
        }),
        navigateTo() {
            return {
                path: `/contactInfo/${this.clientID}/new`,
                query: {newContactInfo: true}
            }
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.getContactInfos();
    },

    methods: {
        initialize() {
            this.contactInfos = [];
        },

        initializePayload() {
            this.payload = {
                query: {
                name: this.client?.Name,
                clientId: this.client?._id,
                generateFile: true,
                page: this.currentPage,
                limit: this.itemsPerPage,
                keyword: this.searchKeyword,
                searchFields: this.headers
                    .filter((h) => h.value !== "actions")
                    .map((h) => h.value),
                },
                endpoints: `contactInfo/client/${this.client?._id}`,
                dynamic: true,
                fileName: `${this.client?.Name}-contact-info.pdf`,
            };
        },

        viewContactInfo(item) {
            this.$router.push({
                path: `/contactInfo/${this.clientID}/update/${item._id}`,
                query: {newContactInfo: false}
            })
        },

        deleteContactInfo(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this information?") &&
            this.contactInfoDelete(id);
        },

        contactInfoDelete(id) {
            axios.delete(`${url}/contactInfo/${id}`).then((response) => {
                this.getContactInfos();
                if (response.status === 400) {
                    response.json().then(function (data) {
                        return data.msg;
                    });
                }
                this.msg = true;
                this.text =
                    "The contact information record has been deleted successfully.";
            });
        },


        getContactInfos() {
            this.isLoading = true;
            axios
                .get(`${url}/contactInfo/client/${this.clientID}`)
                .then((res) => {
                    this.contactInfos = res.data.results;
                })
                .finally(() => (this.isLoading = false, this.initializePayload()));
        },

        handleActions(action) {
            if (this.$refs.actions) {
                this.$refs.actions.onSelectAction(action);
            } else {
                console.error("reference not found");
            }
        },
    },
};
</script>